import React from 'react';
import { Container, Paper, Typography, Box } from '@mui/material';
import UpdateUserForm from '../components/User/UpdateUserForm';
import MigrationCodeCard from '../components/Migration/MigrationCodeCard';

const SettingsPage = () => {
  return (
    <Container component="main" maxWidth="sm" sx={{ mt: 8, mb: 4 }}>
      <MigrationCodeCard />
      <Paper elevation={3} sx={{ p: { xs: 2, md: 4 }, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h4" gutterBottom>
          Ajustes de la Cuenta
        </Typography>
        <Box sx={{ mt: 1, width: '100%' }}>
          <UpdateUserForm />
        </Box>
      </Paper>
    </Container>
  );
};

export default SettingsPage;